/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skilllevel1Inputs */

const en_entity_skilllevel1 = /** @type {(inputs: Entity_Skilllevel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill-Level`)
};

const de_entity_skilllevel1 = /** @type {(inputs: Entity_Skilllevel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill-Level`)
};

/**
* | output |
* | --- |
* | "Skill-Level" |
*
* @param {Entity_Skilllevel1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skilllevel1 = /** @type {((inputs?: Entity_Skilllevel1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skilllevel1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skilllevel1(inputs)
	return de_entity_skilllevel1(inputs)
});
export { entity_skilllevel1 as "entity_skillLevel" }